import { PagePayload } from '@core/interface/core';
import {
  AddVehicleResponse,
  DeletedVehicle,
  Vehicle,
  VehicleError,
  VehicleResponse,
} from '@core/interface/fleet/vehicle';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const VehicleActions = createActionGroup({
  source: 'Vehicle',
  events: {
    'Load Vehicles': props<PagePayload>(),
    'Load Vehicles Success': props<VehicleResponse>(),
    'Load Vehicles Failure': props<VehicleError>(),
    'Add Edit Vehicle': props<Vehicle>(),
    'Add Vehicle Success': props<AddVehicleResponse>(),
    'Update Vehicle Success': props<AddVehicleResponse>(),
    'Add Vehicle Failure': props<VehicleError>(),
    'Update Vehicle Failure': props<VehicleError>(),
    'Delete Vehicle': props<{ id: number }>(),
    'Delete Vehicle Success': props<DeletedVehicle>(),
    'Delete Vehicle Failure': props<VehicleError>(),
    'Reset Delete status': emptyProps(),
    'Reset Vehicles': emptyProps(),
    'Export Excel Vehicles': props<PagePayload>(),
    'Export Excel Vehicles Success': props<VehicleResponse>(),
    'Export Excel Vehicles Failure': props<VehicleError>(),
  },
});
